import { useAppSelector } from 'hooks/reduxHooks'
import { selectLoggedIn } from 'selectors/accountSelectors'
import { canAccessStaffChat } from 'tripPlanner/utils/staffChatAccess'

// Visibility only. Opening a chat still goes through the backend's ownership/staff checks.
export function useCanAccessChatQa(): boolean {
  const loggedIn = useAppSelector(selectLoggedIn)
  const email = useAppSelector(state => state.auth.account.email)
  const spoofed = useAppSelector(state => state.auth.account.isSpoofed)
  const agentEmail = useAppSelector(state => state.auth.account.spoofedBy?.email)
  return loggedIn && (canAccessStaffChat(email) || (spoofed && canAccessStaffChat(agentEmail)))
}
